import React, {useEffect, useState} from 'react'
import ManageReservation from './ManageReservation'
import {
  useGetCMSPropertiesQuery,
  useGetPMSPropertiesQuery
} from '../../services/guestPortalApi'
import MemberStays from './MemberStays'
import {Loading} from 'react-daisyui'
import LoadingSpinner from '../common/LoadingSpinner'
import {LoadingSpinnerSize} from '../common/LoadingSpinner'

const MemberStaysTab = ({reservationId}: {reservationId?: string}) => {
  const propertiesQuery = useGetCMSPropertiesQuery({})
  const pmsPropertiesQuery = useGetPMSPropertiesQuery({})

  const [manageStay, setManageStay] = useState(!!reservationId)
  const [currentStay, setCurrentStay] = useState(reservationId || null)
  const [isPastReservation, setIsPastReservation] = useState(false)

  const onManageStay = (stay: any) => {
    setManageStay(true)
    setCurrentStay(stay.reservationId)
    // Check if this reservation came from the cancelled/past reservations section
    setIsPastReservation(stay.isPastReservation || false)
  }

  useEffect(() => {
    setManageStay(!!reservationId)
    setCurrentStay(reservationId || null)
  }, [reservationId])

  const onStayModification = () => {
    // setTimeout(() => {
    //   // There is a delay in the update of the reservation status returned here
    //   // so we need to wait a few seconds before refetching the data
    //   // staysQuery.refetch()
    //   // canceledStaysQuery.refetch()
    // }, 4000)
  }

  useEffect(() => {}, [manageStay])

  return (
    <div className="rows gap-4">
      {manageStay && currentStay ? (
        <div>
          {propertiesQuery.data && (
            <ManageReservation
              reservationId={currentStay}
              propertiesData={propertiesQuery.data}
              onStayModification={onStayModification}
              isPastReservation={isPastReservation}
            ></ManageReservation>
          )}
          {propertiesQuery.isLoading && (
            <LoadingSpinner size={LoadingSpinnerSize.Large} />
          )}
        </div>
      ) : (
        <MemberStays onManageStay={onManageStay}></MemberStays>
      )}
    </div>
  )
}

export default MemberStaysTab
